import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import linkedCardService from "@irati/perksgo/services/linkedcards"
import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import {Body, H3} from "@irati/ui/src/Typography"
import perksGOBadge from "@irati-web/perksgo/src/images/perksGO_badge.svg"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {FormattedMessage} from "@irati/utils/lang"

import {navigateToCategoryWithTag} from "../../helpers/categories/navigateToCategoryWithTag"
import StyledSectionHeader, {GridWrapper, Primary, Image} from "./styled/SectionHeader"

interface Props {
  headerText?: string,
  bodyText?: string,
  className?: string,
  tag?: {}
}

interface State {
  load: Promise<any>,
  hasLinkedCards?: boolean
}

class EarnSectionHeader extends PureComponent<Props, State> {
  state = {
    load: hangPromise(),
    hasLinkedCards: undefined
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  componentDidMount = () => {
    this.setState({load: this.hasLinkedCards()})
  }

  hasLinkedCards = () => {
    const userId = authentication.user().uuid
    return linkedCardService.getPerksGOCards({userId}).then((linkedCards) => {
      this.setState({hasLinkedCards: linkedCards.length > 0})
    })
  }

  render() {
    const idNamespace = id("earn-section-header", this.props)

    const {className, tag, headerText, bodyText} = this.props
    const {hasLinkedCards, load} = this.state

    return (
      <Loading load={load}>
        <StyledSectionHeader id={idNamespace} className={className}>
          <GridWrapper>
            <Primary>
              <Image src={perksGOBadge} />
              <div>
                <H3 id={id("title", idNamespace)} paddingBottom={1}>
                  {headerText}
                </H3>
                <Body small>{bodyText}</Body>
              </div>
            </Primary>
            {hasLinkedCards && (
              <Button cta onClick={() => navigateToCategoryWithTag(tag, this.context)}>
                <FormattedMessage id="perks.earnSectionHeader.seeAllButton.text" />
                <Icon icon={IconTypes.arrowRight} marginLeft />
              </Button>
            )}
          </GridWrapper>
        </StyledSectionHeader>
      </Loading>
    )
  }
}

export default EarnSectionHeader
